import useQueryParamState from "src/hooks/queryParamState/useQueryParamState";
import { resetPagination } from "src/components/browse-shared/usePaginationState";

export function useIsCodeSearchState() {
  return useQueryParamState<boolean>(
    function getValue(query) {
      return query.codeSearch === "1";
    },
    function getQuery(value: boolean) {
      if (value) {
        return { codeSearch: 1 };
      } else {
        return { codeSearch: undefined };
      }
    },
    { onChangeTransform: resetPagination }
  );
}
